import { YearHeading } from "../../../../src/data/articles/the-history-of-the-cube-format/YearHeading.tsx";
import Chan from "../../../../src/data/articles/the-history-of-the-cube-format/SampleDecks/Chan.tsx";
import * as React from 'react';
export default {
  YearHeading,
  Chan,
  React
};